// extracted by mini-css-extract-plugin
export var overlayContinuousFade = "ContentfulAnimation-module--overlayContinuousFade--CALFh";
export var overlay = "ContentfulAnimation-module--overlay--G-VJr";
export var softFadeInOut = "ContentfulAnimation-module--softFadeInOut--8fED6";